import React from 'react';

import { Switch, Route } from 'react-router-dom';

import { getClientRoutes } from 'ctm-builders';
import { pageContext } from 'ctm-util-functions';

import { ErrorContainer404 } from '../server/assets/404';

/**
 * Construct and return the routes for the app. If this is being run on the server, return null as the server uses
 * it's own StaticRouter. Routes are wrapped in a <Switch/> to ensure that only the first matching route is used.
 * @param {Object} store - The application Redux store
 * @param {Boolean} isSSR - True if this being called on the server for Server-Side Rendering
 * @returns {Array} - The <Switch/> component containing the routes if run on the client, null if run on the server.
 */
export const getRoutes = (store, isSSR) => {
    pageContext.setProps({ store, isSSR });
    return getClientRoutes(isSSR).concat(<Route component={ErrorContainer404} key="404" />);
};
